<template>
    <metainfo>
        <template v-slot:title="{ content, metainfo }">{{ content ? `${content}` : `Digital Nomad Cafes` }}</template>
    </metainfo>

    <router-view/>
</template>

<script>
import {mapActions} from "vuex";

export default {
    name: "App",
    methods: {
        ...mapActions([
            'getAuthStatus'
        ])
    },
    created() {
        this.getAuthStatus();
    }
}
</script>
